// import React, { Component } from "react";
import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Input,
  InputGroup,
  
  NavLink as NavLink1,
  Nav,
  InputGroupText,
} from "reactstrap";
import API from "api.js";
import ChromeCheck from "views/ChromeCheckGlobal.jsx";
// import { thead, tbody } from "variables/general";

import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import Filters from "components/PracticeMaterial/New/Filters";
import ListTable from "components/PracticeMaterial/New/ListTable";
import QuestionListPagination from "components/PracticeMaterial/New/QuestionListPagination";
import SubcategoryTitle from "Datasets/SubcategoryTitle.json";
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";
import SearchFilter from "components/PracticeMaterial/New/Filters/SearchFilter";
import OtherFilters from "components/PracticeMaterial/New/Filters/OtherFilters";
const MONTHLY_PREDICTIONS = 2;

// class QuestionList extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [],
//       total: 0,
//       page: 1,
//       search: "",
//       count: 10,
//       mark: "all",
//       attempted: "all",
//       activeTab: MONTHLY_PREDICTIONS,
//       type: this.props.params?.id,
//       prediction: 1,
//       all_ok: true,
//       orderby: "desc",
//       complexity: "all",
//       filterByVid: "none",
//       displaying_items: 10,
//     };
//   }

//   componentDidMount() {
//     this.chromeFunc();
//     this.getListApi(1);
//   }

//   chromeFunc = () => {
//     if (![1, 2, 3, 4, 5].includes(parseInt(this.state.type))) {
//       return true;
//     }

//     let isChrome =
//       /Chrome/.test(navigator.userAgent) &&
//       !/Edg/.test(navigator.userAgent) &&
//       /Google Inc/.test(navigator.vendor) &&
//       !/Chromium/.test(navigator.userAgent);
//     if (navigator.mediaDevices.getUserMedia === undefined) {
//       this.setState({ all_ok: false });
//     } else {
//       navigator.mediaDevices.getUserMedia(
//         { audio: true },
//         () => {
//           console.log("Permission Granted");
//           this.setState({ all_ok: isChrome });
//         },
//         () => {
//           this.setState({ all_ok: false });
//           console.log("Permission Denied");
//         }
//       );
//     }
//   };

//   changePagination = (p) => {
//     let page = this.state.page + p;
//     if (page > 0 && page * 10 - 10 < this.state.total) {
//       this.setState({ page: page });
//       this.getListApi(page);
//     }
//   };

//   getListApi = (page) => {
//     let {
//       type,
//       prediction,
//       search,
//       count,
//       activeTab,
//       mark,
//       attempted,
//       complexity,
//       orderby,
//       filterByVid,
//     } = this.state;
//     API({
//       method: "GET",
//       url: `question/${type}?prediction=${prediction}&page=${page}&search=${search}&count=${count}&type=${activeTab}&mark=${mark}&attempted=${attempted}&complexity=${complexity}&orderby=${orderby}&list=1&practice=true&filterByVid=${filterByVid}`,
//     })
//       .then((data) => {
//         this.setState({
//           data: data.data.data,
//           total: data.data.total,
//         });
//         localStorage.setItem("orderby", orderby);
//       })
//       .catch(() => {});
//   };

//   changeInput = (e) => {
//     let { name, value } = e.target;
//     this.setState({ [name]: value }, () => {
//       if (name === "count") {
//         this.setState({ page: 1 }, () => {
//           this.getListApi(1);
//         });
//       } else if (name === "mark") {
//         this.getListApi(1);
//       } else if (name === "attempted") {
//         this.getListApi(1);
//       } else if (name === "complexity") {
//         this.getListApi(1);
//       } else if (name === "orderby" || name === "filterByVid") {
//         this.getListApi(1);
//       }
//     });
//   };

//   clickSearch = () => {
//     this.getListApi(1);
//   };

//   getComplexity = (comp) => {
//     let complexity = "";
//     switch (comp) {
//       case 0:
//         complexity = <span className="badge badge-primary">Easy</span>;
//         break;
//       case 1:
//         complexity = <span className="badge badge-primary">Medium</span>;
//         break;
//       case 2:
//         complexity = <span className="badge badge-primary">Difficult</span>;
//         break;
//     }
//     return complexity;
//   };

//   _handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       this.getListApi(1);
//     }
//   };

//   /**
//    * Change Pagination.
//    */
//   paginationChange = (page) => {
//     this.setState(
//       {
//         page,
//       },
//       () => {
//         this.getListApi(page);
//       }
//     );
//   };

//   /**
//    * Update display items per page. in table.
//    */
//   updateListingItems = (items, page) => {
//     this.setState(
//       {
//         count: items,
//         page: page,
//       },
//       () => {
//         // run api again to get updated listing.
//         this.getListApi(page);
//       }
//     );
//   };

//   handleSearchChange = (e) => {
//     const { value } = e.target;
//     this.setState({
//       search: value,
//     });
//   };

//   /**
//    * Search by ExplanationVid.
//    */
//   searchByExplanationVideo = (e, val) => {
//     console.log(val);
//   };

//   showCurrentMonth = () => {
//     const months = [
//       "January",
//       "February",
//       "March",
//       "April",
//       "May",
//       "June",
//       "July",
//       "August",
//       "September",
//       "October",
//       "November",
//       "December",
//     ];

//     const d = new Date();
//     const month = months[d.getMonth()];

//     return ` - ${month}`;
//   };

//   render() {
//     let {
//       page,
//       count,
//       all_ok,
//       activeTab,
//       type,
//       mark,
//       attempted,
//       complexity,
//       search,
//       filterByVid,
//     } = this.state;
//     let i = page * count - count;
//     const title = SubcategoryTitle[parseInt(type)];
//     console.log("All Props>>>>>>>>>>", this.state);
//     return (
//       <>
//         {!this.state.all_ok && <ChromeCheck />}
//         {this.state.all_ok && (
//           <div className="siteContent readAloudPage p-0">
//             <DashboardHeader
//               title="Monthly Prediction"
//               sutitle={this.showCurrentMonth()}
//             />
//             <div className="dashboard-content-wrapper read-aloud-wrapper">
//               <Card>
//                 <CardHeader className="p-0">
//                   <CardTitle tag="h4">{title}</CardTitle>

//                   <div className="read-aloud-header">
//                     <Filters
//                       MONTHLY_PREDICTIONS={MONTHLY_PREDICTIONS}
//                       showData={this.showData}
//                       activeTab={activeTab}
//                       search={search}
//                       handleSearchChange={this.handleSearchChange}
//                       clickSearch={this.clickSearch}
//                       type={parseInt(this.state.type)}
//                       filterByVid={filterByVid}
//                       searchByExplanationVideo={this.searchByExplanationVideo}
//                       onlyMonthlyPrediction={true}
//                     />
//                   </div>
//                 </CardHeader>
//                 <CardBody>
//                   <div className="tab-content" id="myTabContent">
//                     <div
//                       className="tab-pane fade show active"
//                       id="all"
//                       role="tabpanel"
//                       aria-labelledby="all-tab"
//                     >
//                       <div className="table-responsive">
//                         <ListTable
//                           data={this.state.data}
//                           type={this.state.type}
//                           activeTab={activeTab}
//                           mark={mark}
//                           attempted={attempted}
//                           complexity={complexity}
//                           filterByVid={filterByVid}
//                           search={search}
//                           page={page}
//                           listing={this.state.displaying_items}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <QuestionListPagination
//                     total={this.state.total}
//                     listing={this.state.displaying_items}
//                     updateListingItems={this.updateListingItems}
//                     page={page}
//                     paginationChange={this.paginationChange}
//                   />
//                 </CardBody>
//               </Card>
//             </div>
//           </div>
//         )}
//       </>
//     );
//   }
// }

// export default QuestionList;

const QuestionList = () => {
  const { id } = useParams(); // ✅ react-router v6 params
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(10);
  const [mark, setMark] = useState("all");
  const [attempted, setAttempted] = useState("all");
  const [activeTab, setActiveTab] = useState(MONTHLY_PREDICTIONS);
  const [prediction] = useState(1);
  const [allOk, setAllOk] = useState(true);
  const [orderby, setOrderby] = useState("desc");
  const [complexity, setComplexity] = useState("all");
  const [filterByVid, setFilterByVid] = useState("none");
  const [displayingItems, setDisplayingItems] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  
  

  const type = id; // ✅ taken from params

  // chromeFunc
  const chromeFunc = useCallback(() => {
    if (![1, 2, 3, 4, 5].includes(parseInt(type))) {
      return true;
    }

    // let isChrome =
    //   /Chrome/.test(navigator.userAgent) &&
    //   !/Edg/.test(navigator.userAgent) &&
    //   /Google Inc/.test(navigator.vendor) &&
    //   !/Chromium/.test(navigator.userAgent);

    // if (navigator.mediaDevices.getUserMedia === undefined) {
    //   setAllOk(false);
    // } else {
    //   navigator.mediaDevices.getUserMedia(
    //     { audio: true },
    //     () => {
    //       console.log("Permission Granted");
    //       setAllOk(isChrome);
    //     },
    //     () => {
    //       setAllOk(false);
    //       console.log("Permission Denied");
    //     }
    //   );
    // }
  }, [type]);
  
  const changeFilter = (key, value) => {
  switch(key) {
    case 'orderby': setOrderby(value); break;
    case 'complexity': setComplexity(value); break;
    case 'attempted': setAttempted(value); break;
    case 'mark': setMark(value); break;
    case 'filterByVid': setFilterByVid(value); break;
  }
  setPage(1);
};

const clearFilters = () => {
  setOrderby("desc");
  setComplexity("all");
  setAttempted("all");
  setMark("all");
  setFilterByVid("none");
  setSearch("");
};

  // API Call
  const getListApi = useCallback(
    (pageNum = 1) => {
      setIsLoading(true)
      API({
        method: "GET",
        url: `question/${type}?prediction=${prediction}&page=${pageNum}&search=${search}&count=${count}&type=${activeTab}&mark=${mark}&attempted=${attempted}&complexity=${complexity}&orderby=${orderby}&list=1&practice=true&filterByVid=${filterByVid}`,
      })
        .then((res) => {
          setData(res.data.data);
          setTotal(res.data.total);
          localStorage.setItem("orderby", orderby);
          setIsLoading(false)
        })
        .catch(() => {
          setIsLoading(false)
        });
    },
    [
      type,
      prediction,
      search,
      count,
      activeTab,
      mark,
      attempted,
      complexity,
      orderby,
      filterByVid,
    ]
  );

  // on mount
  useEffect(() => {
    // chromeFunc();
    getListApi(1);
  }, [chromeFunc, getListApi]);

  useEffect(() => {
  getListApi(1);
}, [orderby, complexity, attempted, mark, filterByVid]);

  // pagination change
  const paginationChange = (newPage) => {
    setPage(newPage);
    getListApi(newPage);
  };

  // update items per page
  const updateListingItems = (items, newPage) => {
    setCount(items);
    setPage(newPage);
    getListApi(newPage);
  };

  // search input
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  // trigger search
  const clickSearch = () => {
    getListApi(1);
  };

  // show current month
  const showCurrentMonth = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    return ` - ${months[d.getMonth()]}`;
  };

  // complexity badge
  const getComplexity = (comp) => {
    switch (comp) {
      case 0:
        return <span className="badge badge-primary">Easy</span>;
      case 1:
        return <span className="badge badge-primary">Medium</span>;
      case 2:
        return <span className="badge badge-primary">Difficult</span>;
      default:
        return null;
    }
  };

  const titleIndexOverride = { 18: 17, 19: 18, 20: 19 };
  const typeInt = parseInt(type);
  const title = SubcategoryTitle[titleIndexOverride[typeInt] ?? typeInt];

  return (
    <>
      {!allOk && <ChromeCheck />}
      {allOk && (
        <div className="siteContent readAloudPage p-0">
          <DashboardHeader
            title="Monthly Prediction"
            sutitle={showCurrentMonth()}
          />
          <div className="dashboard-content-wrapper read-aloud-wrapper qlist-header table-scrolling">
            <Card className="listing_height">
              {/* <CardHeader className="p-0">
                <CardTitle tag="h4">{title}</CardTitle>
                <div className="read-aloud-header">
                  <Filters
                    MONTHLY_PREDICTIONS={MONTHLY_PREDICTIONS}
                    showData={() => { }}
                    activeTab={activeTab}
                    search={search}
                    handleSearchChange={handleSearchChange}
                    clickSearch={clickSearch}
                    type={parseInt(type)}
                    filterByVid={filterByVid}
                    searchByExplanationVideo={(e, val) => console.log(val)}
                    onlyMonthlyPrediction={true}
                  />
                </div>
                
              </CardHeader> */}
              <CardHeader className="p-0 w-100">
  <div className="read-aloud-header w-100">
    {/* Left side - Title, Tabs, Search */}
    <div className="header-col-1">
      <div className="header-col-content">
        <CardTitle tag="h4">{title}</CardTitle>
        <Filters
          MONTHLY_PREDICTIONS={MONTHLY_PREDICTIONS}
          showData={() => {}}
          activeTab={activeTab}
          search={search}
          handleSearchChange={handleSearchChange}
          clickSearch={clickSearch}
          type={parseInt(type)}
          filterByVid={filterByVid}
          searchByExplanationVideo={(e, val) => console.log(val)}
          onlyMonthlyPrediction={true}
        />
      </div>
      <SearchFilter
        search={search}
        handleSearchChange={handleSearchChange}
        clickSearch={clickSearch}
      />
    </div>

    {/* Right side - Filter Dropdowns */}
    <div className="header-col-2">
      <OtherFilters
        orderby={orderby}
        complexity={complexity}
        attempted={attempted}
        mark={mark}
        filterByVid={filterByVid}
        changeFilter={changeFilter}
        type={parseInt(type)}
        clearFilters={clearFilters}
      />
    </div>
  </div>
</CardHeader>
              {
                isLoading ? <Spinner /> :
                  data?.length === 0 ? (
                    <EmptyData />
                  ) :
                    <CardBody>
                      <div className="tab-content" id="myTabContent">
                        <div
                          className="tab-pane fade show active"
                          id="all"
                          role="tabpanel"
                          aria-labelledby="all-tab"
                        >
                          <div className="table-responsive">
                            <ListTable
                              data={data}
                              type={type}
                              activeTab={activeTab}
                              mark={mark}
                              attempted={attempted}
                              complexity={complexity}
                              filterByVid={filterByVid}
                              search={search}
                              page={page}
                              listing={count}
                               testType={"1"}
                            />
                          </div>
                        </div>
                      </div>

                      <QuestionListPagination
                        total={total}
                        listing={count}
                        updateListingItems={updateListingItems}
                        page={page}
                        paginationChange={paginationChange}
                      />
                    </CardBody>
              }
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionList;
